import { Modal } from 'antd';
import { useUnit } from 'effector-react';
import Descriptions from 'antd/es/descriptions';
import {
  $clusterProblemDetails,
  changeClusterProblemDetailsEv,
} from '../../models/overviewModel/index.js';

function ClusterProblemDetails() {
  const clusterProblemDetails = useUnit($clusterProblemDetails);
  const changeClusterProblemDetails = useUnit(changeClusterProblemDetailsEv);

  const onClose = () => changeClusterProblemDetails(null);

  return (
    <Modal
      open={!!clusterProblemDetails}
      footer={null}
      onCancel={onClose}
      width="50vw"
    >
      <Descriptions
        column={1}
        items={[
          {
            key: 1,
            label: <div style={{ width: 200 }}>Наименование</div>,
            children: clusterProblemDetails?.name || '',
          },
          {
            key: 2,
            label: <div style={{ width: 200 }}>Дата регистрации</div>,
            children: clusterProblemDetails?.registration_date || '',
          },
          {
            key: 3,
            label: <div style={{ width: 200 }}>Предлагаемое решение</div>,
            children: clusterProblemDetails?.solution || '',
          },
          {
            key: 4,
            label: <div style={{ width: 200 }}>Позиция ГО</div>,
            children: clusterProblemDetails?.gov_position || '',
          },
          {
            key: 5,
            label: <div style={{ width: 200 }}>Протокольные поручения</div>,
            children: '',
          },
          {
            key: 6,
            label: <div style={{ width: 200 }}>Наличие продлений сроков</div>,
            children: clusterProblemDetails?.protocol_overdue || '',
          },
          {
            key: 7,
            label: <div style={{ width: 200 }}>Фактическая дата решения</div>,
            children: '',
          },
          {
            key: 8,
            label: <div style={{ width: 200 }}>Решение</div>,
            children: '',
          },
        ]}
      />
    </Modal>
  );
}

export default ClusterProblemDetails;
